import { DragSortableDirective } from './drag-sortable.directive';

export const DIRECTIVES = [
  DragSortableDirective
];
